import Repository from "./Repository";

const resource = "/Persona";

export default {
  get({ cancelToken = null }) {
    return Repository.get(`${resource}`, { cancelToken });
  }
};
